import React from "react";
import { SiteType } from "@/types";
import { round } from "@/utils";

type SiteTableRowProps = {
  site: SiteType;
  active?: boolean;
  onClick: React.MouseEventHandler;
};

function SiteTableRow({
  site,
  active = false,
  onClick,
}: Readonly<SiteTableRowProps>) {
  return (
    <tr
      className="m-0 border-t p-0 text-xs hover:cursor-pointer hover:bg-accent/40 data-[state='active']:bg-primary data-[state='active']:text-primary-foreground data-[state='active']:cursor-default"
      data-state={active ? "active" : "default"}
      onClick={onClick}
    >
      <td className="px-4 py-2 text-left">{site.site}</td>
      <td className="px-4 py-2 text-right">
        <span title={site.latitude.toString()}>{round(site.latitude, 2)}</span>
      </td>
      <td className="px-4 py-2 text-right">
        <span title={site.longitude.toString()}>
          {round(site.longitude, 2)}
        </span>
      </td>
      <td className="px-4 py-2 text-right">
        <span title={site.altitude.toString()}>{round(site.altitude, 0)}</span>
      </td>
    </tr>
  );
}

export { SiteTableRow };
